<h2>Form Controls</h2>

<p>
  Use these custom form controls when you want built-in validation and
  formatting. Otherwise, use a standard HTML control, such as &lt;input&gt;.
</p>
<p>Required:</p>
<ul>
  <li>[(ngModel)]</li>
</ul>

<p>Optional:</p>
<ul>
  <li>
    [label] (string) - The text to be used for the user-facing field label
  </li>
  <li>[required] = (boolean) (default = false)</li>
  <li>
    [groupName] = (string) - Apply a user-friendly name of the form or form
    section that the input belongs to
  </li>
  <li>[style] = (string) - Apply custom styles</li>
  <li>
    [type] = (enum TextModes) (Numeric | AlphaNumeric | Email | Phone | Password
    | CurrencyUSD | Date | PostalCodeUS | PostalCodeCAN)
  </li>
  <li>
    [validateOn] = (change | blur) - Determines when formatting and validation
    is triggered, in cases where it's automatically applied (such as with
    currency)
  </li>
</ul>

<table style="width: 100%">
  <tr>
    <td>Textbox - Required</td>
    <td>
      <app-text-input [label]="'First Name'" [required]="true"></app-text-input>
    </td>
    <td style="width: 65%">
      <textarea codeSnippet>
                <app-text-input [label]="'First Name'" [required]="true"></app-text-input>
            </textarea
      >
    </td>
  </tr>
  <tr>
    <td>Textbox - Optional</td>
    <td>
      <app-text-input
        [label]="'First Name'"
        [required]="false"
      ></app-text-input>
    </td>
    <td style="width: 65%">
      <textarea codeSnippet>
                <app-text-input [label]="'First Name'" [required]="false" [(ngModel)]="customerFirstName"></app-text-input>
            </textarea
      >
    </td>
  </tr>

  <tr>
    <td>Email</td>
    <td>
      <app-text-input
        [label]="'Email address'"
        [groupName]="'Primary User'"
        [style]="'width:300px;'"
        [type]="InputTextModesEnum.Email"
        [required]="false"
      ></app-text-input>
    </td>
    <td style="width: 65%">
      <textarea codeSnippet>
                <app-text-input [label]="'Email address'" [groupName]="'Primary User'" [style]="'width:300px;'" [type]="InputTextModesEnum.Email" [required]="false" [(ngModel)]="_user.emailAddress"></app-text-input>
            </textarea
      >
    </td>
  </tr>

  <tr>
    <td>Phone Number</td>
    <td>
      <app-text-input
        [label]="'Customer Phone'"
        [type]="InputTextModesEnum.Phone"
      ></app-text-input>
    </td>
    <td style="width: 65%">
      <textarea codeSnippet>
                <app-text-input [label]="'Email address'" [groupName]="'Primary User'" [style]="'width:300px;'" [type]="InputTextModesEnum.Email" [required]="false" [(ngModel)]="_user.emailAddress"></app-text-input>
            </textarea
      >
    </td>
  </tr>

  <tr>
    <td>Currency (USD)</td>
    <td>
      <app-text-input
        [label]="'Total Amount'"
        [validateOn]="'change'"
        [type]="InputTextModesEnum.CurrencyUSD"
      ></app-text-input>
    </td>
    <td style="width: 65%">
      <textarea codeSnippet>
                <app-text-input [label]="'Total Amount'" [validateOn]="'change'" [type]="InputTextModesEnum.CurrencyUSD"></app-text-input>
            </textarea
      >
    </td>
  </tr>

  <tr>
    <td>Custom</td>
    <td>
      <app-text-input
        [label]="'Only letters'"
        [validateOn]="'change'"
        [regex]="'^[a-zA-Z]*$'"
        [hint]="'aaaBBBCCC'"
      ></app-text-input>
    </td>
    <td style="width: 65%">
      <textarea codeSnippet>
                <app-text-input [label]="'Only letters'" [validateOn]="'change'" [regex]="'^[a-zA-Z]*$'" [hint]="'aaaBBBCCC'"></app-text-input>
            </textarea
      >
    </td>
  </tr>
</table>

<div>Text Area</div>

<div>Checkbox</div>

<div>Radio</div>
